import React from 'react';

export const CuePad = ({ filled, label, hint, active, onClick, testid }) => (
  <button
    onClick={onClick}
    onContextMenu={(e) => { e.preventDefault(); onClick(e, true); }}
    className={`h-11 rounded-lg text-[10px] font-bold uppercase tracking-widest transition-all border ${
      active ? 'bg-[#FFB000] text-black border-[#FFB000] shadow-[0_0_15px_rgba(255,176,0,0.6)]'
      : filled ? 'bg-[#FFB000]/15 text-[#FFB000] border-[#FFB000]/40 hover:bg-[#FFB000]/25'
      : 'bg-black/40 text-[#A1A1AA] border-white/10 hover:border-[#FFB000]/40 hover:text-[#FFB000]'
    }`}
    data-testid={testid}
    title={hint}
  >
    {label}
  </button>
);
